export const badgeTheme = {
  root: {
    borderRadius: '50%',
  },
  fontSize: 'var(--three-fourth-rem)',
  sm: {
    minWidth: 'var(--rem)',
    height: 'var(--rem)',
  },
  lg: {
    minWidth: 'var(--one-half-rem)',
    height: 'var(--one-half-rem)',
  },
  xl: {
    minWidth: 'var(--two-rem)',
    height: 'var(--two-rem)',
  },
  extend: {
    agility: {
      alignitems: 'center',
    },
  },
  colorScheme: {
    light: {
      secondary: {
        background: 'var(--p-primary-100)',
        color: 'var(--p-black)',
      },
      success: {
        background: 'var(--p-success-500)',
        color: 'var(--p-white)',
      },
      info: {
        background: 'var(--p-primary-500)',
        color: 'var(--p-white)',
      },
      warn: {
        background: 'var(--p-warning-500)',
        color: 'var(--p-white)',
      },
      danger: {
        background: 'var(--p-danger-500)',
        color: 'var(--p-white)',
      },
    },
    dark: {
      secondary: {
        background: 'var(--p-primary-700)',
        color: 'var(--p-white)',
      },
      success: {
        background: 'var(--p-success-500)',
        color: 'var(--p-white)',
      },
      info: {
        background: 'var(--p-primary-500)',
        color: 'var(--p-white)',
      },
      warn: {
        background: 'var(--p-warning-500)',
        color: 'var(--p-white)',
      },
      danger: {
        background: 'var(--p-danger-500)',
        color: 'var(--p-white)',
      },
    },
  },
  css: ({ dt }: any) => `
  .p-badge {
    align-items: ${dt('badge.agility.alignitems')};
  }
  `,
};
